import type {
	MacroContentNode,
	MacroPreloadHandler,
	MacroPreloadContext,
} from '../preloadMacroData.ts';

/**
 * Preload handler for the popular-labels macro.
 *
 * TODO: Implement real GraphQL preloading once popularLabelsMacro is added to AGG schema.
 * Currently a no-op since the macro uses mock data.
 */
export const popularLabelsPreloadHandler: MacroPreloadHandler = {
	extensionKey: 'popular-labels',

	routes: ['view', 'space-overview'],

	preload: async (_node: MacroContentNode, _context: MacroPreloadContext): Promise<void> => {
		// No-op until real GraphQL query is available
	},
};
